const REQUIRED_ENV = {
  VITE_BASE_URL: 'Base API URL',
  VITE_BASE_FILE_URL: 'Base file URL',
  VITE_BASE_STREAM_URL: 'Base stream URL',
} as const;

type RequiredEnvKey = keyof typeof REQUIRED_ENV;

const readEnv = (key: RequiredEnvKey): string => {
  const value = import.meta.env[key];
  if (typeof value === 'string' && value.trim().length > 0) {
    return value;
  }

  throw new Error(
    `Missing required environment variable "${key}" (${REQUIRED_ENV[key]}). ` +
    'Add it to your .env file or deployment configuration before starting the app.'
  );
};

export const env = {
  baseUrl: readEnv('VITE_BASE_URL').replace(/\/$/, ''),
  baseFileUrl: readEnv('VITE_BASE_FILE_URL').replace(/\/$/, ''),
  baseStreamUrl: readEnv('VITE_BASE_STREAM_URL').replace(/\/$/, ''),
  version: 1
} as const;

export type AppEnv = typeof env;

